export const EMAIL_BUILDER_FORMATTING_RAIL_ATTR = "data-email-builder-formatting-rail";
